// import React from "react";
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   ListItemButton,
//   Collapse,
// } from "@mui/material";
// import { Link, useLocation } from "react-router-dom";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import BusinessIcon from "@mui/icons-material/Business";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import WorkIcon from "@mui/icons-material/Work";
// import PeopleIcon from "@mui/icons-material/People";
// import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
// import VpnKeyIcon from "@mui/icons-material/VpnKey";
// import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
// import ListAltIcon from "@mui/icons-material/ListAlt";
// import DescriptionIcon from "@mui/icons-material/Description";
// import { useNavigate } from "react-router-dom";

// const drawerWidth = 220;

// import SettingsIcon from "@mui/icons-material/Settings";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import TuneIcon from "@mui/icons-material/Tune";
// import EmailIcon from "@mui/icons-material/Email";

// const navLinks = [
//   {
//     text: "Dashboard",
//     icon: <DashboardIcon fontSize="small" />,
//     path: "/admin",
//   },
//   {
//     text: "Jobs",
//     icon: <BusinessCenterIcon fontSize="small" />,
//     children: [
//       {
//         text: "Job Orders",
//         icon: <ListAltIcon fontSize="small" />,
//         path: "/admin/job-orders",
//       },
//       {
//         text: "Job descriptions",
//         icon: <DescriptionIcon fontSize="small" />,
//         path: "/admin/jobs",
//       },
//       {
//         text: "Questions",
//         icon: <AssignmentIndIcon fontSize="small" />,
//         path: "/admin/questions",
//       },
//     ],
//   },
//   {
//     text: "Organizations",
//     icon: <BusinessIcon fontSize="small" />,
//     path: "/admin/organizations",
//   },
//   {
//     text: "Candidates",
//     icon: <PeopleIcon fontSize="small" />,
//     path: "/admin/candidates",
//   },
//   {
//     text: "Users",
//     icon: <PeopleIcon fontSize="small" />,
//     path: "/admin/users",
//   },
// ];

// const baseItemStyles = {
//   mx: 1,
//   my: 0.25,
//   borderRadius: 1.5,
//   px: 1.5,
//   minHeight: 40,
//   "& .MuiListItemIcon-root": {
//     minWidth: 32,
//     color: "text.secondary",
//   },
//   "& .MuiListItemText-primary": {
//     fontSize: "0.85rem",
//     fontWeight: 600,
//     letterSpacing: 0.1,
//   },
//   "&:hover": {
//     backgroundColor: "#F3F4F6",
//     transform: "translateX(2px)",
//     transition: "background-color 0.2s ease, transform 0.15s ease",
//   },
//   "&.Mui-selected": {
//     backgroundColor: "#E5E7EB",
//     color: "#111827",
//     "& .MuiListItemIcon-root": {
//       color: "#111827",
//     },
//     "& .MuiListItemText-primary": {
//       fontWeight: 700,
//     },
//     "&:hover": {
//       backgroundColor: "#D1D5DB",
//     },
//   },
// };

// const nestedItemStyles = {
//   ...baseItemStyles,
//   mx: 1.5,
//   px: 2,
//   "& .MuiListItemText-primary": {
//     fontSize: "0.8rem",
//     fontWeight: 400,
//   },
// };

// export default function AdminSidebar({ selected }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const currentPath = location.pathname;

//   const [openSettings, setOpenSettings] = React.useState(() => {
//     const saved = localStorage.getItem("adminSidebarOpenSettings");
//     return saved === null ? false : saved === "true";
//   });
//   const [openJobs, setOpenJobs] = React.useState(() => {
//     const saved = localStorage.getItem("adminSidebarOpenJobs");
//     return saved === null ? false : saved === "true";
//   });

//   const handleSettingsClick = () => {
//     setOpenSettings((prev) => {
//       localStorage.setItem("adminSidebarOpenSettings", !prev);
//       return !prev;
//     });
//   };

//   const handleJobsClick = () => {
//     setOpenJobs((prev) => {
//       localStorage.setItem("adminSidebarOpenJobs", !prev);
//       return !prev;
//     });
//   };

//   // Path matcher that works for nested routes (e.g. /admin/jobs/123)
//   const pathMatches = (path) => {
//     if (!path) return false;
//     if (!currentPath) return false;
//     return (
//       currentPath === path ||
//       currentPath.startsWith(path + "/") // nested routes under this path
//     );
//   };

//   // Prefer explicit `selected` prop if you pass it; otherwise use URL
//   const matchItem = (label, path) => {
//     if (selected) {
//       return selected === label || selected === path;
//     }
//     return pathMatches(path);
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: { xs: "100%", sm: drawerWidth },
//         flexShrink: 0,
//         zIndex: (theme) => theme.zIndex.appBar - 1,
//         "& .MuiDrawer-paper": {
//           width: drawerWidth,
//           boxSizing: "border-box",
//           background: (theme) =>
//             `linear-gradient(180deg, ${theme.palette.grey[50]} 0%, ${theme.palette.grey[100]} 100%)`,
//           color: "text.primary",
//           left: 0,
//           top: { xs: 56, sm: 64 },
//           height: {
//             xs: "calc(100vh - 56px)",
//             sm: "calc(100vh - 64px)",
//           },
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "flex-start",
//           borderRight: "1px solid",
//           borderColor: "divider",
//           boxShadow: "2px 0 12px rgba(15,23,42,0.06)",
//           borderRadius: { xs: 0, sm: 3 },
//           ["@media (min-width:600px) and (orientation: landscape)"]: {
//             top: 60,
//             height: "calc(100vh - 60px)",
//           },
//         },
//       }}
//       PaperProps={{
//         sx: {
//           height: {
//             xs: "calc(100vh - 56px)",
//             sm: "calc(100vh - 64px)",
//           },
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "flex-start",
//           ["@media (min-width:600px) and (orientation: landscape)"]: {
//             height: "calc(100vh - 48px)",
//           },
//         },
//       }}
//     >
//       <Box
//         sx={{
//           overflow: "auto",
//           flex: 1,
//           mt: 1,
//           pb: 2,
//         }}
//       >
//         <List
//           sx={{
//             pt: 1,
//             pb: 0,
//           }}
//         >
//           {navLinks.map((link) => {
//             const anyChildSelected = link.children?.some((child) =>
//               matchItem(child.text, child.path)
//             );

//             const isTopSelected =
//               matchItem(link.text, link.path) || Boolean(anyChildSelected);

//             return link.children ? (
//               <React.Fragment key={link.text}>
//                 <ListItem disablePadding>
//                   <ListItemButton
//                     onClick={handleJobsClick}
//                     sx={{
//                       ...baseItemStyles,
//                       mb: 0.5,
//                     }}
//                     selected={isTopSelected}
//                   >
//                     <ListItemIcon>{link.icon}</ListItemIcon>
//                     <ListItemText
//                       primary={link.text}
//                       primaryTypographyProps={{
//                         fontSize: "0.85rem",
//                         fontWeight: 700,
//                       }}
//                     />
//                     <ExpandMore
//                       sx={{
//                         ml: "auto",
//                         fontSize: 18,
//                         transform: openJobs
//                           ? "rotate(180deg)"
//                           : "rotate(0deg)",
//                         transition: "transform 0.2s ease",
//                       }}
//                     />
//                   </ListItemButton>
//                 </ListItem>
//                 <Collapse in={openJobs} timeout="auto" unmountOnExit>
//                   <List
//                     component="div"
//                     disablePadding
//                     sx={{
//                       borderLeft: "1px solid",
//                       borderColor: "divider",
//                       ml: 1.5,
//                       pl: 0.5,
//                     }}
//                   >
//                     {link.children.map((child) => (
//                       <ListItemButton
//                         key={child.text}
//                         component={Link}
//                         to={child.path}
//                         sx={{
//                           ...nestedItemStyles,
//                           mt: 0.25,
//                         }}
//                         selected={matchItem(child.text, child.path)}
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <ListItemIcon>{child.icon}</ListItemIcon>
//                         <ListItemText
//                           primary={child.text}
//                           primaryTypographyProps={{
//                             fontSize: "0.8rem",
//                             fontWeight: 400,
//                           }}
//                         />
//                       </ListItemButton>
//                     ))}
//                   </List>
//                 </Collapse>
//               </React.Fragment>
//             ) : (
//               <ListItem key={link.text} disablePadding>
//                 <ListItemButton
//                   component={Link}
//                   to={link.path}
//                   selected={isTopSelected}
//                   sx={baseItemStyles}
//                 >
//                   <ListItemIcon>{link.icon}</ListItemIcon>
//                   <ListItemText
//                     primary={link.text}
//                     primaryTypographyProps={{
//                       fontSize: "0.85rem",
//                       fontWeight: 700,
//                     }}
//                   />
//                 </ListItemButton>
//               </ListItem>
//             );
//           })}

//           {/* Settings Section */}
//           <ListItem disablePadding sx={{ mt: 0.5 }}>
//             <ListItemButton
//               onClick={handleSettingsClick}
//               sx={{
//                 ...baseItemStyles,
//                 mb: 0.5,
//               }}
//               selected={[
//                 "/admin/settings/locations",
//                 "/admin/settings/job-types",
//                 "/admin/settings/statuses",
//                 "/admin/settings/roles",
//                 "/admin/settings/permissions",
//                 "/admin/settings/email",
//                 "/admin/settings/google-calendar",
//               ].some(pathMatches)}
//             >
//               <ListItemIcon>
//                 <SettingsIcon fontSize="small" />
//               </ListItemIcon>
//               <ListItemText
//                 primary="Settings"
//                 primaryTypographyProps={{
//                   fontSize: "0.85rem",
//                   fontWeight: 700,
//                 }}
//               />
//               <ExpandMore
//                 sx={{
//                   ml: "auto",
//                   fontSize: 18,
//                   transform: openSettings
//                     ? "rotate(180deg)"
//                     : "rotate(0deg)",
//                   transition: "transform 0.2s ease",
//                 }}
//               />
//             </ListItemButton>
//           </ListItem>
//           <Collapse in={openSettings} timeout="auto" unmountOnExit>
//             <List
//               component="div"
//               disablePadding
//               sx={{
//                 borderLeft: "1px solid",
//                 borderColor: "divider",
//                 ml: 1.5,
//                 pl: 0.5,
//               }}
//             >
//               <ListItemButton
//                 component={Link}
//                 to="/admin/settings/locations"
//                 sx={nestedItemStyles}
//                 selected={matchItem(
//                   "Locations",
//                   "/admin/settings/locations"
//                 )}
//               >
//                 <ListItemIcon>
//                   <BusinessIcon fontSize="small" />
//                 </ListItemIcon>
//                 <ListItemText primary="Locations" />
//               </ListItemButton>
//               <ListItemButton
//                 component={Link}
//                 to="/admin/settings/job-types"
//                 sx={nestedItemStyles}
//                 selected={matchItem(
//                   "Job Types",
//                   "/admin/settings/job-types"
//                 )}
//               >
//                 <ListItemIcon>
//                   <WorkIcon fontSize="small" />
//                 </ListItemIcon>
//                 <ListItemText primary="Job Types" />
//               </ListItemButton>
//               <ListItemButton
//                 component={Link}
//                 to="/admin/settings/statuses"
//                 sx={nestedItemStyles}
//                 selected={matchItem(
//                   "Statuses",
//                   "/admin/settings/statuses"
//                 )}
//               >
//                 <ListItemIcon>
//                   <TuneIcon fontSize="small" />
//                 </ListItemIcon>
//                 <ListItemText primary="Statuses" />
//               </ListItemButton>
//               <ListItemButton
//                 component={Link}
//                 to="/admin/settings/roles"
//                 sx={nestedItemStyles}
//                 selected={matchItem("Roles", "/admin/settings/roles")}
//               >
//                 <ListItemIcon>
//                   <AdminPanelSettingsIcon fontSize="small" />
//                 </ListItemIcon>
//                 <ListItemText primary="Roles" />
//               </ListItemButton>
//               <ListItemButton
//                 component={Link}
//                 to="/admin/settings/permissions"
//                 sx={nestedItemStyles}
//                 selected={matchItem(
//                   "Permissions",
//                   "/admin/settings/permissions"
//                 )}
//               >
//                 <ListItemIcon>
//                   <VpnKeyIcon fontSize="small" />
//                 </ListItemIcon>
//                 <ListItemText primary="Permissions" />
//               </ListItemButton>
//               <ListItemButton
//                 component={Link}
//                 to="/admin/settings/email"
//                 sx={nestedItemStyles}
//                 selected={matchItem(
//                   "Email Settings",
//                   "/admin/settings/email"
//                 )}
//               >
//                 <ListItemIcon>
//                   <EmailIcon fontSize="small" />
//                 </ListItemIcon>
//                 <ListItemText primary="Email Settings" />
//               </ListItemButton>
//               <ListItemButton
//                 component={Link}
//                 to="/admin/settings/google-calendar"
//                 sx={nestedItemStyles}
//                 selected={matchItem(
//                   "G-Calendar Settings",
//                   "/admin/settings/google-calendar"
//                 )}
//               >
//                 <ListItemIcon>
//                   <CalendarTodayIcon fontSize="small" />
//                 </ListItemIcon>
//                 <ListItemText primary="G-Calendar Settings" />
//               </ListItemButton>
//             </List>
//           </Collapse>
//         </List>
//       </Box>
//     </Drawer>
//   );
// }


import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  ListItemButton,
  Collapse,
  Typography,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BusinessIcon from "@mui/icons-material/Business";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import PeopleIcon from "@mui/icons-material/People";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import ExpandMore from "@mui/icons-material/ExpandMore";
import TuneIcon from "@mui/icons-material/Tune";
import EmailIcon from "@mui/icons-material/Email";

const drawerWidth = 244;

const navLinks = [
  {
    text: "Dashboard",
    icon: <DashboardIcon fontSize="small" />,
    path: "/admin",
  },
  {
    text: "Jobs",
    icon: <BusinessCenterIcon fontSize="small" />,
    children: [
      {
        text: "Job Orders",
        icon: <ListAltIcon fontSize="small" />,
        path: "/admin/job-orders",
      },
      {
        text: "Job Descriptions",
        icon: <DescriptionIcon fontSize="small" />,
        path: "/admin/jobs",
      },
      {
        text: "Questions",
        icon: <AssignmentIndIcon fontSize="small" />,
        path: "/admin/questions",
      },
    ],
  },
  {
    text: "Organizations",
    icon: <BusinessIcon fontSize="small" />,
    path: "/admin/organizations",
  },
  {
    text: "Candidates",
    icon: <PeopleIcon fontSize="small" />,
    path: "/admin/candidates",
  },
  {
    text: "Users",
    icon: <PeopleIcon fontSize="small" />,
    path: "/admin/users",
  },
];

export default function AdminSidebar({ selected }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const location = useLocation();
  const currentPath = location.pathname;

  const accent = dark ? "#fb923c" : "#f97316";
  const drawerBg = dark ? "#0b1020" : "#ffffff";
  const drawerBgAlt = dark ? "#0f172a" : "#f8f8fb";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";
  const borderStrong = dark ? "rgba(99, 179, 237, 0.22)" : "#d4d4e4";

  const [openSettings, setOpenSettings] = React.useState(() => {
    const saved = localStorage.getItem("adminSidebarOpenSettings");
    return saved === null ? false : saved === "true";
  });

  const [openJobs, setOpenJobs] = React.useState(() => {
    const saved = localStorage.getItem("adminSidebarOpenJobs");
    return saved === null ? true : saved === "true";
  });

  const handleSettingsClick = () => {
    setOpenSettings((prev) => {
      localStorage.setItem("adminSidebarOpenSettings", String(!prev));
      return !prev;
    });
  };

  const handleJobsClick = () => {
    setOpenJobs((prev) => {
      localStorage.setItem("adminSidebarOpenJobs", String(!prev));
      return !prev;
    });
  };

  const pathMatches = (path) => {
    if (!path || !currentPath) return false;
    return currentPath === path || currentPath.startsWith(path + "/");
  };

  const matchItem = (label, path) => {
    if (selected) {
      return selected === label || selected === path;
    }
    return pathMatches(path);
  };

  const baseItemStyles = {
    mx: 1.25,
    my: 0.35,
    borderRadius: "14px",
    px: 1.5,
    minHeight: 44,
    color: mid,
    transition:
      "background-color 0.2s ease, color 0.2s ease, transform 0.15s ease, border-color 0.2s ease",
    border: `1px solid transparent`,
    "& .MuiListItemIcon-root": {
      minWidth: 34,
      color: "inherit",
    },
    "& .MuiListItemText-primary": {
      fontSize: "0.88rem",
      fontWeight: 700,
      letterSpacing: "-0.01em",
    },
    "&:hover": {
      backgroundColor: dark
        ? "rgba(255,255,255,0.04)"
        : "rgba(15,15,26,0.03)",
      color: text,
      transform: "translateX(2px)",
    },
    "&.Mui-selected": {
      background: alpha(accent, dark ? 0.14 : 0.08),
      color: accent,
      border: `1px solid ${alpha(accent, 0.22)}`,
      "& .MuiListItemIcon-root": {
        color: accent,
      },
      "& .MuiListItemText-primary": {
        fontWeight: 800,
      },
      "&:hover": {
        background: alpha(accent, dark ? 0.18 : 0.1),
      },
    },
  };

  const nestedItemStyles = {
    ...baseItemStyles,
    mx: 1.5,
    px: 1.75,
    minHeight: 40,
    "& .MuiListItemText-primary": {
      fontSize: "0.82rem",
      fontWeight: 600,
    },
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        zIndex: (t) => t.zIndex.appBar - 1,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          background: `linear-gradient(180deg, ${drawerBg} 0%, ${drawerBgAlt} 100%)`,
          color: text,
          borderRight: `1px solid ${border}`,
          top: { xs: 72, md: 78 },
          height: {
            xs: "calc(100vh - 72px)",
            md: "calc(100vh - 78px)",
          },
          boxShadow: dark
            ? "6px 0 24px rgba(0,0,0,0.22)"
            : "4px 0 20px rgba(15,23,42,0.05)",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: 2,
          pt: 2.25,
          pb: 1.5,
          borderBottom: `1px solid ${border}`,
        }}
      >
        <Typography
          sx={{
            color: accent,
            fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
            fontSize: "10.5px",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            fontWeight: 500,
            mb: 0.75,
          }}
        >
          AjiraHQ
        </Typography>
        <Typography
          sx={{
            color: text,
            fontWeight: 800,
            fontSize: "1.1rem",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
          }}
        >
          Admin Workspace
        </Typography>
      </Box>

      <Box sx={{ overflow: "auto", flex: 1, py: 1.5 }}>
        <List sx={{ pt: 0, pb: 0 }}>
          {navLinks.map((link) => {
            const anyChildSelected = link.children?.some((child) =>
              matchItem(child.text, child.path)
            );

            const isTopSelected =
              matchItem(link.text, link.path) || Boolean(anyChildSelected);

            return link.children ? (
              <React.Fragment key={link.text}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={handleJobsClick}
                    sx={baseItemStyles}
                    selected={isTopSelected}
                  >
                    <ListItemIcon>{link.icon}</ListItemIcon>
                    <ListItemText primary={link.text} />
                    <ExpandMore
                      sx={{
                        ml: "auto",
                        fontSize: 18,
                        color: isTopSelected ? accent : mid,
                        transform: openJobs ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.2s ease",
                      }}
                    />
                  </ListItemButton>
                </ListItem>

                <Collapse in={openJobs} timeout="auto" unmountOnExit>
                  <List
                    component="div"
                    disablePadding
                    sx={{
                      borderLeft: `1px solid ${border}`,
                      ml: 2.25,
                      pl: 0.5,
                      mt: 0.25,
                    }}
                  >
                    {link.children.map((child) => (
                      <ListItemButton
                        key={child.text}
                        component={Link}
                        to={child.path}
                        sx={nestedItemStyles}
                        selected={matchItem(child.text, child.path)}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ListItemIcon>{child.icon}</ListItemIcon>
                        <ListItemText primary={child.text} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </React.Fragment>
            ) : (
              <ListItem key={link.text} disablePadding>
                <ListItemButton
                  component={Link}
                  to={link.path}
                  selected={isTopSelected}
                  sx={baseItemStyles}
                >
                  <ListItemIcon>{link.icon}</ListItemIcon>
                  <ListItemText primary={link.text} />
                </ListItemButton>
              </ListItem>
            );
          })}

          <ListItem disablePadding sx={{ mt: 0.4 }}>
            <ListItemButton
              onClick={handleSettingsClick}
              sx={baseItemStyles}
              selected={[
                "/admin/settings/locations",
                "/admin/settings/job-types",
                "/admin/settings/statuses",
                "/admin/settings/roles",
                "/admin/settings/permissions",
                "/admin/settings/email",
                "/admin/settings/google-calendar",
              ].some(pathMatches)}
            >
              <ListItemIcon>
                <SettingsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Settings" />
              <ExpandMore
                sx={{
                  ml: "auto",
                  fontSize: 18,
                  transform: openSettings ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              />
            </ListItemButton>
          </ListItem>

          <Collapse in={openSettings} timeout="auto" unmountOnExit>
            <List
              component="div"
              disablePadding
              sx={{
                borderLeft: `1px solid ${border}`,
                ml: 2.25,
                pl: 0.5,
                mt: 0.25,
              }}
            >
              <ListItemButton
                component={Link}
                to="/admin/settings/locations"
                sx={nestedItemStyles}
                selected={matchItem("Locations", "/admin/settings/locations")}
              >
                <ListItemIcon>
                  <BusinessIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Locations" />
              </ListItemButton>

              <ListItemButton
                component={Link}
                to="/admin/settings/job-types"
                sx={nestedItemStyles}
                selected={matchItem("Job Types", "/admin/settings/job-types")}
              >
                <ListItemIcon>
                  <WorkIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Job Types" />
              </ListItemButton>

              <ListItemButton
                component={Link}
                to="/admin/settings/statuses"
                sx={nestedItemStyles}
                selected={matchItem("Statuses", "/admin/settings/statuses")}
              >
                <ListItemIcon>
                  <TuneIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Statuses" />
              </ListItemButton>

              <ListItemButton
                component={Link}
                to="/admin/settings/roles"
                sx={nestedItemStyles}
                selected={matchItem("Roles", "/admin/settings/roles")}
              >
                <ListItemIcon>
                  <AdminPanelSettingsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Roles" />
              </ListItemButton>

              <ListItemButton
                component={Link}
                to="/admin/settings/permissions"
                sx={nestedItemStyles}
                selected={matchItem("Permissions", "/admin/settings/permissions")}
              >
                <ListItemIcon>
                  <VpnKeyIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Permissions" />
              </ListItemButton>

              <ListItemButton
                component={Link}
                to="/admin/settings/email"
                sx={nestedItemStyles}
                selected={matchItem("Email Settings", "/admin/settings/email")}
              >
                <ListItemIcon>
                  <EmailIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Email Settings" />
              </ListItemButton>

              <ListItemButton
                component={Link}
                to="/admin/settings/google-calendar"
                sx={nestedItemStyles}
                selected={matchItem(
                  "G-Calendar Settings",
                  "/admin/settings/google-calendar"
                )}
              >
                <ListItemIcon>
                  <CalendarTodayIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="G-Calendar Settings" />
              </ListItemButton>
            </List>
          </Collapse>
        </List>
      </Box>
    </Drawer>
  );
}
